import React from 'react';
import { Page, EditPageContainer, withResolver, withDebug } from 'components/common';
import { compose, withState, withHandlers } from 'recompose';
import { Button, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import Edit from './Edit';
import ContactHistory from './ContactHistory';
import InstallationReport from './InstallationReport';
import withLifecycle from '@hocs/with-lifecycle';
import qs from 'query-string';
import _ from "lodash";
import { findIndex, get, pickBy } from 'lodash';

const tabs = [
  'Job Details',
  'Contact History',
  'Installation Report',
  'Images',
];
const tabDisplay = [
  () => true,
  () => true,
  props => !!props.item.installation_report,
  () => false,
];

const SetTabOnLoad = compose(
  withLifecycle({
    onDidMount: ({ setActiveTab, location, item }) => {
      const query = qs.parse(location.search);
      if(!query['tab']) return;
      const requestedTab = tabs.indexOf(query['tab']);
      if(requestedTab < 0) return;
      tabDisplay[requestedTab]({item}) && setActiveTab(requestedTab);
    },
  })
)(() => null);


export const Manage = ({
  activeTab,
  setActiveTab,
  toggleTab,
  item,
  jobStatuses,
  jobSubStatuses,
  location,
  ...props
}) => {
  var PrevId = 0;
  var NextId = 0;
  var HasPrevNext = false;
  if(location.state && location.state.jobs && location.state.jobs.length > 1) {
    var jobs = [...location.state.jobs];
    jobs.sort((a,b) => { a.id - b.id });
    var index = findIndex(jobs,{id:item.id});
    var prev = index - 1;
    prev = prev < 0 ? prev + jobs.length : prev % jobs.length;
    var next = index + 1;
    next = next > (jobs.length - 1) ? next % jobs.length : next;
    PrevId = jobs[prev].id;
    NextId = jobs[next].id;
    HasPrevNext = true;
  } 

  return (
  <Page title="">
    { HasPrevNext &&
      <div className='row float-right mr-3'>
        <Button className='m-1'> 
          <Link className='text-light' to={{
            pathname:'/manage-job/' + (PrevId),
            state:location.state
          }}> Prev 
          </Link>
        </Button>  
        <Button className='m-1'> 
          <Link className='text-light' to={{
            pathname:'/manage-job/' + (NextId),
            state:location.state
          }}> Next
          </Link>
        </Button>
      </div>
    }
    <Nav pills>
      {tabs.map(
        (t, i) =>
          tabDisplay[i]({ item, ...props }) && (
            <NavItem key={i}>
              <NavLink
                className={classnames({ active: activeTab === i })}
                onClick={e => toggleTab(e, i)}
                href="#"
              >
                {t}
              </NavLink>
            </NavItem>
          )
      )}
      {item && <SetTabOnLoad item={item} location={location} setActiveTab={setActiveTab} />}
    </Nav>
    <br />
    <TabContent activeTab={activeTab}>
      <TabPane tabId={tabs.indexOf('Job Details')}>
        <Edit item={item} jobStatuses={jobStatuses} jobSubStatuses={jobSubStatuses} {...props} readOnly={props.readOnly || props.isComplete}/>
      </TabPane>
      <TabPane tabId={tabs.indexOf('Contact History')}>
        <ContactHistory
          jobId={item.id}
          currentStatus={item.job_status}
          jobStatuses={jobStatuses}
          jobSubStatuses={jobSubStatuses}
          {...props}
        />
      </TabPane>
      <TabPane tabId={tabs.indexOf('Installation Report')}>
        <InstallationReport {...props} data={item.installation_report} location={location} />
      </TabPane>
      {/* <TabPane tabId={tabs.indexOf('Images')}>
        <Images jobId={item.id} {...props} />
      </TabPane> */}
    </TabContent>
  </Page>
)};

const enhance = compose(
  withState('activeTab', 'setActiveTab', tabs.indexOf('Job Details')),
  withState('jobStatuses', 'setJobStatuses', []),
  withState('jobSubStatuses', 'setJobSubStatuses', []),
  withState('isComplete', 'setIsComplete', false),
  EditPageContainer({
    url: 'jobs',
    redirectToSavedItem: false,
    beforeSave: props => item => {
      item = pickBy(item, (v,k) => v);
      return {
        ...item,
        installer: item.hasOwnProperty('installer') ? item['installer'] : null,
        installation_types: item.installation_types.map(i => {
          return i === 1
            ? { installation_type: i, other: item.installation_type_other }
            : { installation_type: i };
        }),
      };
    },
    afterFetched: props => item => {
      const other = item.installation_types.filter(
        i => i.installation_type === 1
      );
      let installation_type_other;
      if (other.length) {
        installation_type_other = other[0].other;
      }
      props.setIsComplete(item.job_status >= 50);
      return {
        ...item,
        installation_types: item.installation_types.map(
          i => i.installation_type
        ),
        installation_type_other,
      };
    },
    saveSuccessHandler: props => resp => {
      props.setIsComplete(resp.data.job_status >= 50);
    }
    }),
    withResolver(
    {
      jobStatuses: () => client => client.get('job_statuses_by_type?filter=all'),
      jobStatusesAll: () => client => client.get('job_statuses'),
      jobSubStatus: () => client => client.get('job_substatuses'),
    },
    {
      onResolved: ({ setJobStatuses, item, setJobSubStatuses }) => ({ jobStatuses, jobStatusesAll, jobSubStatus }) => {
      var statuses = _.get(_.find(jobStatuses, (obj) => obj.type.text == item.order_job_type), 'statuses');
      // var substatuses = _.get(_.find(jobSubStatus, (obj) => obj.type.value == item.job_status), 'subStatuses', []);
      setJobSubStatuses(jobSubStatus);
      if(statuses && statuses.length != 0) {
        setJobStatuses(statuses);
      } else {
        setJobStatuses(jobStatusesAll);
      }
      },
    },
    ),
    withDebug('jobStatuses'),
    withDebug('jobSubStatuses'),
    withHandlers({
    toggleTab: ({ setActiveTab }) => (event, tab) => {
      event.preventDefault();
      setActiveTab(tab);
    },
  }),
);

export default enhance(Manage);



// WEBPACK FOOTER //
// ./src/pages/Jobs/Manage.jsx